import Vue from "vue";
import App from "./App.vue";
import "../src/assets/css/base.css";
import router from './router'
import store from './store'
import ElementUI from "element-ui";
import axios from 'axios'
import UrlEncode from './utils/plugin/UrlEncode.js';
import "element-ui/lib/theme-chalk/index.css";
import './assets/css/font.css'
import md5 from 'js-md5';
import './utils/plugin/flexble'


Vue.use(ElementUI, {size: "small"});
Vue.prototype.$axios = axios
Vue.prototype.$UrlEncode = UrlEncode;
Vue.prototype.$md5 = md5;


new Vue({
  render: (h) => h(App),
  beforeCreate() {
    Vue.prototype.$Bus = this
  },
  store,
  router,
}).$mount("#app");
